import { NotAuthenticatedError } from './api-client';

let onAuthLost: (() => void) | null = null;

export function setOnAuthLost(handler: () => void): void {
  onAuthLost = handler;
}

export async function withAuthBoundary<T>(fn: () => Promise<T>): Promise<T> {
  try {
    return await fn();
  } catch (e) {
    if (e instanceof NotAuthenticatedError) {
      onAuthLost?.();
    }
    throw e;
  }
}
